export default __webpack_public_path__ + "static/media/Terms-Condition.96c042c8.jpg";